import React, { useEffect, useState, useRef, useContext } from "react";

const getWordsAndSpellingTimes = (sentence, time) => {
  return sentence.split(" ").map((word) => {
    const sentenceWithoutSpacesLength =
      sentence.length - sentence.split(" ").length;
    const spellingTime = (word.length / sentenceWithoutSpacesLength) * time;
    return [word, spellingTime];
  });
};

function Word({ word, spellingState = "waiting" }) {
  return <span className={"word " + spellingState}>{word}</span>;
}

function Clause({ words, currentWord }) {
  const geSpellingState = (c, i) => {
    if (c > i) return "spelled";
    if (c === i) return "current";
    return "waiting";
  };
  return (
    <p className="Clause">
      {words.map((word, index) => (
        <Word
          key={index}
          word={word[0]}
          spellingState={geSpellingState(currentWord, index)}
        />
      ))}
    </p>
  );
}

export default function TextPlayer({
  words,
  handleClauseEnd,
  isPlaying,
  setIsPlaying,
  currentWord,
  setCurrentWord,
}) {
  const timer = useRef(null);

  useEffect(() => {
    if (isPlaying && currentWord < words.length) {
      clearInterval(timer.current);
      const [_, st] = words[currentWord];
      timer.current = setTimeout(() => {
        setCurrentWord((c) => c + 1);
      }, st);
    } else if (currentWord === words.length) {
      setCurrentWord(0);
      setIsPlaying(false);
    }
  }, [currentWord, words, handleClauseEnd, isPlaying]);

  return (
    <div>
      <Clause words={words} currentWord={currentWord} />
    </div>
  );
}
